import { Inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
} from '@angular/router';
import { CabConstants } from '../cab.constants';

@Injectable({ providedIn: 'root' })
export class DataUniverseResolver implements Resolve<string> {
  constructor(@Inject('APP_CONFIG') private appConfigService: any) {}

  resolve(route: ActivatedRouteSnapshot) {
    const dataUniverseId = route.paramMap.get('dataUniverseId');
    if (this.appConfigService?.showTrackedAttributeSets$) {
      this.appConfigService.showTrackedAttributeSets$.next(
        dataUniverseId != CabConstants.CLEANROOM
      );
    }
    return dataUniverseId;
  }
}
